export const AuditMenu = {
  routes: [
    {
      name: 'load_audits',
      displayName: 'menu.loads',
      subject_class: 'LoadAudits'
    },
    {
      name: 'order_step_audits',
      displayName: 'menu.order_step_audits',
      subject_class: 'OrderStepAudits'
    },
    {
      name: 'product_audits',
      displayName: 'menu.product_audits',
      subject_class: 'ProductAudits'
    },
    {
      name: 'user_audits',
      displayName: 'menu.user_audits',
      subject_class: 'UserAudits'
    },
  ]
}
